import qs from 'qs'
import axios from '../index'

/**
 * @description 我的业绩列表
 * @author lu
 * @date 2019-10-11
 * @export
 */
export function getReturnList (params) {
  return axios.post('/distributor/load', qs.stringify(params))
}
/**
 * @description 我的业绩销售汇总
 * @author txw
 * @date 2019-12-21
 * @export
 */
export function loadSaleCount (params) {
  return axios.post('/distributor/distribution-sale-count', qs.stringify(params))
}
/**
 * @description 我的业绩提成明细
 * @author txw
 * @date 2019-12-21
 * @export
 */
export function loadSaleDetail (params) {
  return axios.post('/distributor/distribution-sale-detail', qs.stringify(params))
}
